module.exports = __webpack_public_path__ + "img/nbq_power_bac.1c5075bb.png";